var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalPartner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#F17F58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4517 22.065C33.37 22.0533 33.2883 22.0533 33.2067 22.065C31.3983 22.0067 29.9633 20.525 29.9633 18.705C29.9633 16.85 31.4683 15.3333 33.335 15.3333C35.19 15.3333 36.7066 16.8383 36.7066 18.705C36.695 20.525 35.26 22.0067 33.4517 22.065Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.255 30.15C35.9483 31.025 34.1166 31.3517 32.425 31.13C32.8683 30.1733 33.1016 29.1117 33.1133 27.9917C33.1133 26.825 32.8566 25.7167 32.3666 24.7483C34.0933 24.515 35.925 24.8417 37.2433 25.7167C39.0866 26.93 39.0866 28.925 37.255 30.15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5134 22.065C20.595 22.0533 20.6767 22.0533 20.7584 22.065C22.5667 22.0067 24.0017 20.525 24.0017 18.705C24.0017 16.8383 22.4967 15.3333 20.63 15.3333C18.775 15.3333 17.27 16.8383 17.27 18.705C17.27 20.525 18.705 22.0067 20.5134 22.065Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6417 27.9917C20.6417 29.1233 20.8867 30.1967 21.33 31.165C19.685 31.34 17.97 30.99 16.71 30.1617C14.8667 28.9367 14.8667 26.9417 16.71 25.7167C17.9583 24.8767 19.72 24.5383 21.3767 24.725C20.8983 25.705 20.6417 26.8133 20.6417 27.9917Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.14 31.515C27.0466 31.5033 26.9416 31.5033 26.8366 31.515C24.69 31.445 22.975 29.6833 22.975 27.5133C22.9866 25.2967 24.7716 23.5 27 23.5C29.2166 23.5 31.0133 25.2967 31.0133 27.5133C31.0016 29.6833 29.2983 31.445 27.14 31.515Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3483 33.93C21.5867 35.1083 21.5867 37.045 23.3483 38.2117C25.355 39.5533 28.645 39.5533 30.6517 38.2117C32.4133 37.0333 32.4133 35.0967 30.6517 33.93C28.6567 32.5883 25.3667 32.5883 23.3483 33.93Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPartner);
export default __webpack_public_path__ + "static/media/totalPartner.112a51b8.svg";
export { ForwardRef as ReactComponent };